/** Register the PWA service worker (production builds only). */
export async function registerPwa(): Promise<void> {
  if (import.meta.env.DEV) return;
  try {
    const { registerSW } = await import('virtual:pwa-register');
    registerSW({
      immediate: true,
      onOfflineReady() {
        /* cache warmed */
      },
    });
  } catch {
    /* PWA plugin not active in this build */
  }
}
